<template>
  <modal :center="false" :show="visible" modalClasses="modal-xxl">
    <b-row class="sticky-top pt-2 bg-light mt--3 mb-2">
      <b-col sm="12" md="4">
        <b-button class="mb-2" block variant="secondary" @click="handleClose">
          Đóng (Esc)
        </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button block variant="info" @click="doPrint"> <i class="fa fa-print" aria-hidden="true"></i> In </b-button>
      </b-col>
      <b-col sm="12" md="4">
        <b-button :disabled="quotation.id != ''" block variant="success" @click="doSave">
          <i class="fa fa-save" aria-hidden="true"></i>
          {{ quotation.id != '' ? 'Đã lưu báo giá' : 'Lưu Báo giá' }}
        </b-button>
      </b-col>
    </b-row>
    <block ref="bmdal" :nobody="true">
      <div id="print" class="print-box mt-3 mb-3">
        <div class="header text-center">
          <h3>CÔNG TY TNHH ĐAI MI VN</h3>
          ADD : 66/2 Đường LK 2-5, P.Bình Trị Đông, TP.HCM <br />
          Tel: 028-66828806 Email: daimivn@gmail.com <br />
          <hr />
          <h3>QUOTATION</h3>
        </div>
        <br />
        <div class="info">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <b v-if="quotation.customer.short_name"> TO : {{ quotation.customer.short_name }} </b>
                <b v-else> TO : {{ quotation.customer.name }}</b>
              </td>
            </tr>
            <tr>
              <td>
                <div v-if="quotation.customerContact">
                  <b>ATTN : {{ quotation.customerContact.name }}</b>
                  <br />
                  <b>Email : {{ quotation.customerContact.email }}</b>
                </div>
                <div v-else>
                  <b>ATTN : </b><br />
                  <b>Email : </b>
                </div>
              </td>
              <td>
                <div v-if="quotation.customerContact">
                  <span>Tel : {{ quotation.customerContact.phone }}</span>
                  <br />
                  <span>Date : {{ $dateTime(quotation.date) }}</span>
                </div>
                <div v-else>
                  <span>Tel : </span> <br />
                  <span>Date : {{ $dateTime(quotation.date) }}</span>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="data">
          <table class="prtable prtable-bordered">
            <thead>
              <tr>
                <th style="width:1px">No.</th>
                <th style="width:1px">Width</th>
                <th colspan="2" style="min-width:130px">Code Name</th>
                <th>Length</th>
                <th style="width:100px">Colour</th>
                <th>Price</th>
                <th style="width:130px">Remark</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in productQuotations" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.productSpecify.name }}mm</td>
                <td v-if="!item.hiden" :rowspan="item.rowSpan" style="text-align: left;">
                  {{ item.product.name }}
                  <!-- <span v-if="item.productCustom != ''"><br />{{ item.productCustom }}</span> -->
                  <span v-if="item.reason"><br />{{ item.reason.name }}</span>
                </td>
                <td v-if="!item.hiden" :rowspan="item.rowSpan">
                  {{ item.product.code }}
                </td>
                <td>{{ $formatNumber(item.length) }} cm</td>
                <td>
                  <div class="d-flex">
                    <span v-if="item.color" style="width: 50px;    text-align: left;">
                      {{ capitalize(item.colorText) }}
                    </span>
                    <span style="width: 50px;text-align: right;"> {{ item.colorCode }}</span>
                  </div>
                </td>
                <td>
                  <span>
                    {{ $formatCurrency(item.price) }} {{ item.currency }} /
                    {{ item.unit }}
                  </span>
                </td>
                <td>
                  <span v-html="item.note"></span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="footer">
          <table class="prtable">
            <tr>
              <td colspan="2">
                <div v-html="quotation.note"></div>
              </td>
            </tr>
            <tr>
              <td class="text-center" style="vertical-align: top;">
                Trân trọng kính chào <br />
                Best regards
              </td>
              <td class="text-center" style="vertical-align: top;">
                <h5>CÔNG TY TNHH ĐAI MI VN</h5>
                <br />
                <br />
                <br />
                <br />
                <strong>NGÔ QUỐC VINH</strong>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <event @doCancel="handleClose"></event>
    </block>
  </modal>
</template>
<script>
import { capitalize } from '@/utils/string';
export default {
  props: {},
  data() {
    return {
      visible: false,
      quotation: {
        id: '',
        customer: {},
        customerContact: {}
      },
      productQuotations: {}
    };
  },
  methods: {
    setData(quotation, productQuotations) {
      this.quotation = quotation;

      // productQuotations.sort((a, b) => {
      //   if (a.product.name < b.product.name) {
      //     return -1;
      //   }
      //   if (a.product.name > b.product.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      // productQuotations.sort((a, b) => {
      //   if (a.spec.name > b.spec.name) {
      //     return -1;
      //   }
      //   if (a.spec.name < b.spec.name) {
      //     return 1;
      //   }
      //   return 0;
      // });
      productQuotations.sort((a, b) => {
        if (a.product.name < b.product.name) {
          return -1;
        }
        if (a.product.name > b.product.name) {
          return 1;
        } else {
          if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
            return 1;
          }
          if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
            return -1;
          }
          return 0;
        }
      });

      for (let i = 0; i < productQuotations.length; i++) {
        let item = productQuotations[i];
        item.rowSpan = this.checkSameRow(productQuotations, i, (a, b) => {
          return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
        });
      }
      console.log('xxxx', productQuotations);
      this.productQuotations = productQuotations;
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    handleClose() {
      this.visible = false;
    },
    doPrint() {
      this.$print('print');
    },
    doSave() {
      this.$refs.bmdal.block();
      this.$emit('doSave', () => {
        this.quotation.id = true;
        this.$refs.bmdal.unBlock();
      });
    },
    capitalize(s) {
      return capitalize(s);
    }
  }
};
</script>
